import React, { useState, useContext } from 'react'

import useFetchData from 'hooks/fetch-data'
import { snakifyKeys } from 'helpers/formatters'
import enums from 'Constants/enums'

import issues from 'Services/issues'
import { Toast } from 'Snackbar/useToast'

import { get, isEmpty } from 'lodash'
import { StatusComponent } from 'components/common/others'
import { CommentHeader, Comment } from 'components/Issues/components'
import { MinimalButton, ActionButton } from 'components/common/buttons'
import { statusChipOptions, priorityOptions, getChip } from './utlis'
import { AssetImage, necVoilationOptions, nfpa70bOption, oshaVoilationOptions, severityCriteriaOptions, thermalAnomalySubComponentOptions, thermalClassificationOptions, UltrasonicAnomalyOptions } from 'components/WorkOrders/onboarding/utils'
import ImagePreview from 'components/common/image-preview'

import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined'
import CircularProgress from '@material-ui/core/CircularProgress'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LinkOffOutlinedIcon from '@material-ui/icons/LinkOffOutlined'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { makeStyles } from '@material-ui/core/styles'

import Edit from 'components/Issues/edit'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { history } from 'helpers/history'
import getUserRole from 'helpers/getUserRole'
import { handleCompanyAccess } from 'Services/getCompanyAccess'
import { MainContext } from 'components/Main/provider'
import onBoardingWorkorder from 'Services/WorkOrder/on-boarding-wo'

const useStyles = makeStyles({
  table: {
    borderRadius: '5px',
    '& th': {
      fontWeight: 'bold',
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: '10px 8px 5px 10px',
    },
    '& td': {
      border: '1px solid rgba(224, 224, 224, 1)',
      textAlign: 'center',
      padding: '10px 0px 0px 10px',
    },
  },
})

const IssueDetails = ({ issueId }) => {
  const classes = useStyles()
  const userRole = new getUserRole()
  //details
  const handleFormatter = data => {
    handleCompanyAccess({ companyId: get(data, 'clientCompanyId', null), siteId: get(data, 'siteId', null), siteName: get(data, 'siteName', ''), companyName: get(data, 'clientCompanyName', '') }, context, 'Issue')
    return data
  }
  const { data, reFetch: afterSubmit } = useFetchData({ fetch: issues.getDetailById, payload: issueId, formatter: d => handleFormatter(get(d, 'data', {})), externalLoader: true })
  const { color, label } = getChip(data.issueStatus, statusChipOptions)
  const { color: priorityColor, label: priorityLabel } = getChip(data.priority, priorityOptions)
  const [isEditOpen, setIsEditOpen] = useState(false)
  const [anchorObj, setAnchorObj] = useState({})
  //comments
  const [comment, setComment] = useState('')
  const [sending, setSending] = useState(false)
  const { data: comments, loading: commentsLoading, reFetch } = useFetchData({ fetch: issues.getComments, payload: snakifyKeys({ pageSize: 0, pageIndex: 0, searchString: null, assetIssueId: issueId }), formatter: d => get(d, 'data.list', []) })
  const [isPreviewOpen, setPreview] = useState([false, 0])
  const [unlinking, setUnlinking] = useState(false)
  const [imageOrder, setImageOrder] = useState(0)
  const [randomValue, setRandomValue] = useState(Math.random())
  const context = useContext(MainContext)

  const location = useLocation()

  const { data: allDropDownData } = useFetchData({
    fetch: onBoardingWorkorder.getAllDropdownOptionsList,
    payload: {
      dropdown_option_type: [enums.DROPDOWN_OPTIONS.CONDUCTOR_SIZE, enums.DROPDOWN_OPTIONS.OSHA_VIOLATION, enums.DROPDOWN_OPTIONS.NEC_VIOLATION, enums.DROPDOWN_OPTIONS.NFPA70B_VIOLATION, enums.DROPDOWN_OPTIONS.THERMAL_ANAMOLY_SUBCOMPONENT, enums.DROPDOWN_OPTIONS.ULTRASONIC_ANAMOLY, enums.DROPDOWN_OPTIONS.THERMAL_CLASSIFICATION],
    },
    formatter: d => get(d, 'data.list', []),
    defaultValue: [],
    externalLoader: true,
  })

  //
  const parse = key => get(data, [key], 'NA') || 'NA'
  const postComment = async () => {
    if (!isEmpty(comment.trim())) {
      try {
        setSending(true)
        const res = await issues.addComment(snakifyKeys({ assetIssueId: issueId, comment }))
        if (res.success > 0) {
          Toast.success('Comment added successfully !')
          setComment('')
          reFetch()
        } else Toast.error(res.message)
        setSending(false)
      } catch (error) {
        Toast.error('Something went wrong !')
        setSending(false)
      }
    }
  }
  const edit = () => {
    setAnchorObj(data)
    setIsEditOpen(true)
  }
  const unlink = async () => {
    try {
      setUnlinking(true)
      const res = await issues.unlinkIssueFromWorkOrder(snakifyKeys({ assetIssueId: [data.assetIssueId] }))
      if (res.success > 0) {
        Toast.success('Issue unlinked successfully !')
        reFetch()
        afterSubmit()
      } else Toast.error(res.message)
      setUnlinking(false)
    } catch (error) {
      Toast.error('Something went wrong !')
      setUnlinking(false)
    }
  }
  //
  const renderInitialLoader = () => (
    <div style={{ height: 'calc(100%)', fontWeight: 800, gap: '12px' }} className='d-flex flex-column justify-content-center align-items-center'>
      <CircularProgress size={24} thickness={5} />
    </div>
  )
  const renderEmptyState = () => (
    <div style={{ height: 'calc(100%)', fontWeight: 800, gap: '12px' }} className='d-flex flex-column justify-content-center align-items-center'>
      <ChatBubbleOutlineOutlinedIcon style={{ fontSize: '32px', color: '#666' }} />
      <div style={{ color: '#666', marginTop: '12px' }}>No Comments added !</div>
    </div>
  )
  const issueDetails = {
    filter: get(location, 'state.filter', [[73, 13, 69]]),
    pageRows: get(location, 'state.pageRows', 20),
    search: get(location, 'state.search', ''),
    pageIndex: get(location, 'state.pageIndex', 1),
    page: get(location, 'state.page', 0),
  }
  return (
    <div className='d-flex' style={{ background: '#fff', height: 'calc(100vh - 64px)' }}>
      <div style={{ width: '70%', borderRight: '1px solid #dee2e6', padding: '20px' }}>
        <div className='d-flex justify-content-between mb-5'>
          <div className='d-flex align-items-center'>
            <div className='mr-2'>
              <ActionButton
                icon={<ArrowBackIcon fontSize='small' />}
                action={() => history.push({ pathname: '/issues', state: { filter: get(history, 'location.state.filter', null), search: get(history, 'location.state.search', ''), pageRows: get(history, 'location.state.pageRows', 20), pageIndex: get(history, 'location.state.pageIndex', 1) } })}
                tooltip='GO BACK'
              />
            </div>
            <div className='text-bold mr-2 text-md'>{parse('issueTitle').split('_').join(' - ')}</div>
            <StatusComponent color={color} label={label} size='medium' />
          </div>
          <ActionButton hide={data.issueStatus === enums.ISSUE.STATUS.RESOLVED} tooltip='EDIT' action={edit} icon={<EditOutlinedIcon fontSize='small' />} />
        </div>
        <div className='table-responsive dashboardtblScroll' id='style-2' style={{ height: 'calc(100vh - 200px)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '25% 75%', rowGap: '24px' }}>
            <div className='text-bold'>Issue#</div>
            <div>{parse('issueNumber')}</div>
            {parse('issueType') === enums.ISSUE.TYPE.THERMAL_ANAMOLY && (
              <>
                <div className='text-bold'>Thermal Classification</div>
                <div>
                  {get(allDropDownData, `${enums.DROPDOWN_OPTIONS.THERMAL_CLASSIFICATION}`, thermalClassificationOptions)
                    .map(v => ({ ...v, value: parseInt(v.value, 0) }))
                    .find(d => d.value === parse('thermalClassificationId'))?.label ?? 'NA'}
                </div>
                <div className='text-bold'>Issue Location</div>
                <div>{parse('thermalAnomalyLocation')}</div>
                <div className='text-bold'>Sub-Component(OCP's)</div>
                <div>{parse('thermalAnomalySubComponant')}</div>
                <div className='text-bold'>Measured Temp.</div>
                <div>{parse('thermalAnomalyMeasuredTemps')}</div>
                <div className='text-bold'>Reference Temp.</div>
                <div>{parse('thermalAnomalyRefrenceTemps')}</div>
                <div className='text-bold'>Difference Temp.</div>
                <div>{parse('thermalAnomalyMeasuredAmps')}</div>
                <div className='text-bold'>Severity Criteria</div>
                <div>{severityCriteriaOptions.find(d => d.value === parse('thermalAnomalySeverityCriteria'))?.label ?? 'NA'}</div>
                <div className='text-bold'>Problem Description</div>
                <div>{parse('thermalAnomalyProblemDescription')}</div>
                <div className='text-bold'>Corrective Action</div>
                <div>{parse('thermalAnomalyCorrectiveAction')}</div>
                <div className='text-bold'>ABC Phase</div>
                {get(data, 'dynamicFieldJson', []) !== null && (
                  <TableContainer>
                    <Table aria-label='simple table' className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Phase</TableCell>
                          <TableCell align='left'>Circuit #</TableCell>
                          <TableCell align='left'>
                            Current Rating
                            <br /> (AMPS)
                          </TableCell>
                          <TableCell align='left'>
                            Current Draw <br />
                            (AMPS)
                          </TableCell>
                          <TableCell align='left'>
                            Voltage Drop <br />
                            (Millivolts)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {JSON.parse(get(data, 'dynamicFieldJson', []))?.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell component='th' scope='row'>
                              {item.phase}
                            </TableCell>
                            <TableCell align='center'>{item.circuit}</TableCell>
                            <TableCell align='left'>{item.current_draw_amp}</TableCell>
                            <TableCell align='left'>{item.current_rating_amp}</TableCell>
                            <TableCell align='left'>{item.voltage_drop_millivolts}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </>
            )}
            {parse('issueType') === enums.ISSUE.TYPE.ULTRASONIC_ANOMALY && (
              <>
                <div className='text-bold'>Type of Anomaly</div>
                <div>
                  {
                    get(allDropDownData, `${enums.DROPDOWN_OPTIONS.ULTRASONIC_ANAMOLY}`, UltrasonicAnomalyOptions)
                      .map(v => ({ ...v, value: parseInt(v.value, 0) }))
                      .find(d => d.value === parse('typeOfUltrasonicAnamoly'))?.label
                  }
                </div>
                <div className='text-bold'>Location of Anomaly</div>
                <div>{parse('locationOfUltrasonicAnamoly')}</div>
                <div className='text-bold'>Size of Anomaly</div>
                <div>{parse('sizeOfUltrasonicAnamoly')}</div>
              </>
            )}
            {parse('issueType') === enums.ISSUE.TYPE.COMPLIANCE && parse('issueCausedId') === enums.ISSUE.CAUSED.NEC_VIOLATION && (
              <>
                <div className='text-bold'>Code Violation</div>
                <div>
                  {
                    get(allDropDownData, `${enums.DROPDOWN_OPTIONS.NEC_VIOLATION}`, necVoilationOptions)
                      .map(v => ({ ...v, value: parseInt(v.value, 0) }))
                      .find(d => d.value === parse('necViolation'))?.label
                  }
                </div>
              </>
            )}
            {parse('issueType') === enums.ISSUE.TYPE.COMPLIANCE && parse('issueCausedId') === enums.ISSUE.CAUSED.OSHA_VIOLATION && (
              <>
                <div className='text-bold'>Code Violation</div>
                <div>
                  {
                    get(allDropDownData, `${enums.DROPDOWN_OPTIONS.OSHA_VIOLATION}`, oshaVoilationOptions)
                      .map(v => ({ ...v, value: parseInt(v.value, 0) }))
                      .find(d => d.value === parse('oshaViolation'))?.label
                  }
                </div>
              </>
            )}
            {parse('issueType') === enums.ISSUE.TYPE.COMPLIANCE && parse('issueCausedId') === enums.ISSUE.CAUSED.NFPA_70B_VIOLATION && (
              <>
                <div className='text-bold'>NFPA 70B Violation</div>
                <div>
                  {
                    get(allDropDownData, `${enums.DROPDOWN_OPTIONS.NFPA70B_VIOLATION}`, nfpa70bOption)
                      .map(v => ({ ...v, value: parseInt(v.value, 0) }))
                      .find(d => d.value === parse('nfpa70BViolation'))?.label
                  }
                </div>
              </>
            )}
            <div className='text-bold'>Asset</div>
            <div>
              {data.assetName ? (
                <div onClick={e => window.open(`/assets/details/${data.assetId}`)} className='text-bold' style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                  {data.assetName}
                </div>
              ) : (
                'NA'
              )}
            </div>
            <div className='text-bold'>WO #</div>
            <div className='d-flex align-items-center'>
              {data.manualWoNumber ? (
                <div onClick={e => window.open(`/workorders/details/${data.woId}`)} className='text-bold mr-3' style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                  {data.manualWoNumber}
                </div>
              ) : (
                'NA'
              )}
              <ActionButton isLoading={unlinking} hide={!data.manualWoNumber || data.issueStatus === enums.ISSUE.STATUS.RESOLVED} tooltip='UNLINK WORK ORDER' action={unlink} icon={<LinkOffOutlinedIcon fontSize='small' />} />
            </div>
            <div className='text-bold'>Description</div>
            <div>{parse('issueDescription')}</div>
            <div className='text-bold'>Priority</div>
            <div>
              <StatusComponent color={priorityColor} label={priorityLabel} size='medium' />
            </div>
            <div className='text-bold'>Before Photos</div>
            <div className='pb-3 mb-2 d-flex' style={{ overflowX: 'auto', whiteSpace: 'nowrap' }} id='style-1'>
              {get(data, 'issueImageList', [])
                .filter(d => d.imageDurationTypeId === 1)
                .map((d, index) => d.imageDurationTypeId === 1 && <AssetImage readOnly onClick={() => (setPreview([true, 1]), setImageOrder(index))} key={`asset-image-${d.assetIssueImageMappingId}`} url={`${d.imageFileNameUrl}?value=${randomValue}`} randomValue />)}
            </div>
            <div className='text-bold'>After Photos</div>
            <div className='pb-3 mb-2 d-flex' style={{ overflowX: 'auto', whiteSpace: 'nowrap' }} id='style-1'>
              {get(data, 'issueImageList', [])
                .filter(d => d.imageDurationTypeId === 2)
                .map((d, index) => d.imageDurationTypeId === 2 && <AssetImage readOnly onClick={() => (setPreview([true, 2]), setImageOrder(index))} key={`asset-image-${d.assetIssueImageMappingId}`} url={`${d.imageFileNameUrl}?value=${randomValue}`} randomValue />)}
            </div>
            <div className='text-bold'>Resolve Issue Reason</div>
            <div>{parse('resolveIssueReason')}</div>
          </div>
        </div>
      </div>
      <div style={{ width: '30%' }}>
        <CommentHeader />
        <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 190px)', height: 'calc(100vh - 190px)' }}>
          {commentsLoading ? renderInitialLoader() : isEmpty(comments) ? renderEmptyState() : comments.map(d => <Comment key={d.assetIssueCommentsId} data={d} />)}
        </div>

        <div className='d-flex align-items-center p-2'>
          <input type='text' value={comment} onKeyDown={e => e.key === 'Enter' && postComment()} onChange={e => setComment(e.target.value)} placeholder='Add Comment' className={`minimal-input-base mr-2`} style={{ padding: '8px 16px' }} />
          <MinimalButton variant='contained' color='primary' text='Post' loadingText='Posting...' loading={sending} disabled={sending} onClick={postComment} />
        </div>
      </div>
      {isEditOpen && <Edit obj={anchorObj} isEdit open={isEditOpen} afterSubmit={afterSubmit} onClose={() => setIsEditOpen(false)} allDropDownData={allDropDownData} />}
      {isPreviewOpen[0] && (
        <ImagePreview
          open={isPreviewOpen[0]}
          onClose={() => setPreview([false, 0])}
          imageIndex={imageOrder}
          images={get(data, 'issueImageList', []).filter(d => d.imageDurationTypeId === isPreviewOpen[1])}
          urlKey='imageFileNameUrl'
          hideRotateButton={data.issueStatus === enums.ISSUE.STATUS.RESOLVED ? true : false}
          reFetch={() => setRandomValue(Math.random())}
        />
      )}
    </div>
  )
}

export default IssueDetails
